import React from 'react';
import { InterventionLadderStepModel } from '../../../api-service/clients';
import { formatNumber } from '../../../utilities';
import { InternalExternalSplit, InterventionLadderStepSection } from './intervention-cost';

export function formatSuppliers(count: number) {
  return count === 1 ? 'leverandør' : 'leverandører';
}

export function formatActivitiesWithUnknownSupplier(count: number) {
  return `${formatNumber(count)} ${count === 1 ? 'aktivitet' : 'aktiviteter'} uden kendt leverandør`;
}

interface InterventionLadderStepSuppliersProps {
  step: InterventionLadderStepModel;
  isSelected: boolean;
  onSelect: () => void;
}

export function InterventionLadderStepSuppliers({ step, isSelected, onSelect }: InterventionLadderStepSuppliersProps) {
  const { suppliers } = step;
  return (
    <InterventionLadderStepSection
      heading="Leverandører"
      value={formatNumber(suppliers.total)}
      unit="stk."
      isSelected={isSelected}
      onSelect={onSelect}
      ariaLabel={`Leverandører på trin ${step.step}: ${formatNumber(suppliers.total)}`}
    >
      <InternalExternalSplit
        internal={suppliers.internal}
        external={suppliers.external}
        format={formatNumber}
        label={`${formatNumber(suppliers.internal)} interne, ${formatNumber(suppliers.external)} eksterne`}
      />
    </InterventionLadderStepSection>
  );
}
